import React from 'react';
import './Card.css';

interface CardProps {
  title: string;
  description?: string;
  icon?: string;
  onClick?: () => void;
  children?: React.ReactNode;
  className?: string;
}

const Card: React.FC<CardProps> = ({
  title,
  description,
  icon,
  onClick,
  children,
  className = ''
}) => {
  const cardClasses = `card ${onClick ? 'card--clickable' : ''} ${className}`.trim();

  return (
    <div className={cardClasses} onClick={onClick}>
      {icon && <span className="card-icon">{icon}</span>}
      <div className="card-content">
        <h3 className="card-title">{title}</h3>
        {description && <p className="card-description">{description}</p>}
        {children}
      </div>
    </div>
  );
};

export default Card;
